import {
  BuildingStorefrontIcon,
  ChartBarIcon,
  ChatBubbleBottomCenterTextIcon,
  CircleStackIcon,
  CpuChipIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  DocumentArrowUpIcon,
  DocumentDuplicateIcon,
  EnvelopeIcon,
  LanguageIcon,
  NewspaperIcon,
  PencilIcon,
  QuestionMarkCircleIcon,
  StarIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
} from "@heroicons/react/24/outline"
import {
  AppWindowIcon,
  Blocks,
  BookOpen,
  DatabaseZap,
  Phone,
  TestTube,
} from "lucide-react"

export const features: {
  name: string
  icon: any
}[] = [
  {
    name: "Authentication",
    icon: UserIcon,
  },
  {
    name: "Database",
    icon: CircleStackIcon,
  },
  {
    name: "Subscription",
    icon: CreditCardIcon,
  },
  {
    name: "Emails",
    icon: EnvelopeIcon,
  },
  {
    name: "Credits",
    icon: CurrencyDollarIcon,
  },
  {
    name: "Multi-tenancy",
    icon: DocumentDuplicateIcon,
  },
  {
    name: "SEO",
    icon: BuildingStorefrontIcon,
  },
  {
    name: "Style",
    icon: PencilIcon,
  },
  {
    name: "Community",
    icon: UsersIcon,
  },
  {
    name: "Support",
    icon: QuestionMarkCircleIcon,
  },
  {
    name: "File storage",
    icon: DocumentArrowUpIcon,
  },
  {
    name: "Admin panel",
    icon: UserPlusIcon,
  },
  {
    name: "Analytics",
    icon: ChartBarIcon,
  },
  {
    name: "Customer support",
    icon: ChatBubbleBottomCenterTextIcon,
  },
  {
    name: "Testimonials",
    icon: StarIcon,
  },
  {
    name: "Blog",
    icon: NewspaperIcon,
  },
  {
    name: "i18n",
    icon: LanguageIcon,
  },
  {
    name: "AI",
    icon: CpuChipIcon,
  },
  {
    name: "CRM",
    icon: Blocks,
  },
  {
    name: "API",
    icon: AppWindowIcon,
  },
  {
    name: "Available on IOS",
    icon: Phone,
  },
  {
    name: "Available on Android",
    icon: Phone,
  },
  {
    name: "Caching",
    icon: DatabaseZap,
  },
  {
    name: "Documentation",
    icon: BookOpen,
  },
  {
    name: "A/B Testing",
    icon: TestTube,
  },
]
